import { axiosTracker } from '../../axios-wizard';
import { axiosProtected } from '../../axios-wizard';
import * as actions from '../../store/actions/index';
import { URLS } from '../../urls';

export const pushEvent = (data) => {
    const url = '/api/events/'
    const event_data = {
                         event: {
                           action: data['action'],
                           data: data,
                         }
                       }

    return dispatch => {
      if (URLS['BACKEND'] === 'https://productselector.de') {
        return axiosTracker.post( url, event_data )
      } else {
        return Promise.reject(new Error('fail')).then(function(error) {
  // nicht aufgerufen
}, function(error) {
  //console.log(error); // Stacktrace
});
      }
    };

};



export const pushProtectedEvent = (data) => {
    const url = '/api/events/internal'
    const event_data = {
                         event: {
                           action: data['action'],
                           data: data,
                         }
                       }

    return dispatch => {
        if (URLS['BACKEND'] === 'https://productselector.de') {
          return axiosProtected.post( url, event_data )
        } else {
          return Promise.reject(new Error('fail')).then(function(error) {
  // nicht aufgerufen
}, function(error) {
  console.log(error); // Stacktrace
});
        }
    };

};

export const eventFirstVisit = (key, q) => {
  if (q === 'k1h2') {
    return dispatch => dispatch( pushEvent({action: 'ref_produktmappe', id: key, value: q}))
  }
  if (q === '2rhde2') {
    return dispatch => dispatch( pushEvent({action: 'ref_website', id: key, value: q}))
  }
}


export const eventDirectVisit = (id) => {
  return dispatch => dispatch( pushEvent({action: 'direct_visit'}))
}

export const eventStartProductSelector = () => {
  if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
    return dispatch => dispatch( pushProtectedEvent({action: 'start_product_selector'})).then( () => dispatch(actions.wizardUnfinished()) )
  } else {
    return dispatch => dispatch( pushEvent({action: 'start_product_selector'})).then( () => dispatch(actions.wizardUnfinished()) )
  }
}

export const eventFinishProductSelector = (wizard_finished_status) => {

  if (wizard_finished_status !== false) {
    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      return dispatch => dispatch( pushProtectedEvent({action: 'finish_product_selector'})).then( () => dispatch(actions.wizardFinished()) )
    } else {
      return dispatch => dispatch( pushEvent({action: 'finish_product_selector'})).then( () => dispatch(actions.wizardFinished()) )
    }
  } else {
    return dispatch => dispatch( ()=> null )
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/events.js